module.exports = __webpack_public_path__ + "static/media/AbisoyeOlagbaiye.d8a02b7d.jpg";